import { MouseEventHandler, ReactElement } from 'react';
import styles from './ui-inline-alert.module.scss';
import { UIText } from '../ui-text';
import { UIIcon } from '../ui-icon';

type UIInlineAlertProps = {
    text: string;
    onClose?: MouseEventHandler<HTMLButtonElement>;
};
export function UIInlineAlert(props: UIInlineAlertProps): ReactElement {
    const { text, onClose } = props;
    return (
        <div className={styles.container}>
            <UIText>{text}</UIText>
            {onClose && (
                <button className={styles.button} onClick={onClose}>
                    <UIIcon name="x" size={14} className={styles.icon} />
                </button>
            )}
        </div>
    );
}
